<script>
    import * as Translations from '@scanex/translations';
    import {createEventDispatcher} from 'svelte';
    import './Info.css';

    export let sceneId = '';
    export let platform = '';
	export let productType = ''; //
	//export let granules = [];
    export let date = '';
	//export let openDate = '';
    //export let order = {};
    export let contractId = ''; // Удалил ниже
    export let time = '';
	//export let productType = ''; //
    export let name = '';

    Translations.add('en', {
        sceneId: 'Scene ID',
        platform: 'Platform',
        date: 'Acquisition Date',
        time: 'Acqusition Time (UTC)',
        parameter: 'Parameter',
        value: 'Value'
    });

    Translations.add('ru', {
        sceneId: 'Идентификатор сцены',
        platform: 'Платформа',
        date: 'Дата съемки', // * Дата добавления заказа
        time: 'Время съемки (UTC)',
        parameter: 'Параметр',
        value: 'Значение',
    });    
    
    const dispatch = createEventDispatcher();

    let container;

    export function adjustPosition ({top, left}) {
        container.style.top = `${top}px`;
        container.style.left = `${left}px`;
    }

</script>

<div class="scene-info" bind:this="{container}">
    <table class="header" cellpadding="0" cellspacing="0">
        <tr>
            <td>{platform}</td>
            <td>{date}</td>
            <td on:click|stopPropagation="{() => dispatch('close')}">
                <i class="icon close"></i>
            </td>
        </tr>        
    </table>
    <table class="content" cellpadding="0" cellspacing="0">
        <tr>
            <th>{Translations.translate('parameter')}</th>
            <th>{Translations.translate('value')}</th>
        </tr>
        <tr>
            <td>{Translations.translate('sceneId')}</td>
            <td>{sceneId}</td>
        </tr>
        <tr>
            <td>{Translations.translate('platform')}</td>
            <td>{platform}</td>
        </tr>
        <tr>
            <td>{'Тип снимка'}</td>
            <td>{name}</td>
        </tr>
        <tr>
            <td>{Translations.translate('date')}</td>
            <td>{date}</td>
        </tr>
        <tr>
            <td>{Translations.translate('time')}</td>
            <td>{""}</td>
        </tr>
    </table>
</div>
